"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("../utils/Utils");
const vue_1 = __importDefault(require("vue"));
const MenuWindow_vue_1 = __importDefault(require("./components/MenuWindow.vue"));
const SystemRequirement_vue_1 = __importDefault(require("./components/environment/SystemRequirement.vue"));
const HelpMenu_vue_1 = __importDefault(require("./components/help/HelpMenu.vue"));
const GuideMenu_vue_1 = __importDefault(require("./components/guide/GuideMenu.vue"));
const Notification_vue_1 = __importDefault(require("./components/notification/Notification.vue"));
const MaintenanceDialog_vue_1 = __importDefault(require("./components/MaintenanceDialog.vue"));
const EventModal_vue_1 = __importDefault(require("./components/EventModal.vue"));
const AboutDataDeletionModal_vue_1 = __importDefault(require("./components/AboutDataDeletionModal.vue"));
exports.default = vue_1.default.extend({
    components: {
        MenuWindow: MenuWindow_vue_1.default,
        SystemRequirement: SystemRequirement_vue_1.default,
        HelpMenu: HelpMenu_vue_1.default,
        GuideMenu: GuideMenu_vue_1.default,
        Notification: Notification_vue_1.default,
        MaintenanceDialog: MaintenanceDialog_vue_1.default,
        EventModal: EventModal_vue_1.default,
        AboutDataDeletionModal: AboutDataDeletionModal_vue_1.default,
    },
    data() {
        return {
            repeatPatternUrl: 'url(images/game/common/repeat/bg_repeatPattern.png)',
            titleScreenUrl: 'url(images/top/img_top.png)',
            linkIconUrl: 'url(images/top/icon_warau.png)',
            menuIconUrl: 'url(images/top/icon_menu.png)',
            borderImageUrl: 'url(images/game/common/img_dialog_frame.png)',
        };
    },
    methods: {
        startButtonHandler() {
            window.location.href = '/auth/warau/request_token';
        },
        menuButtonHandler() {
            this.$store.commit('showComponent', {
                component: 'menuWindow',
                isShow: true,
            });
        },
        checkMaintenanceMode() {
            const maintenanceTag = document.getElementsByName('maintenance')[0];
            const content = maintenanceTag.getAttribute('content');
            if (content === 'true') {
                this.$store.commit('showComponent', {
                    component: 'maintenanceDialog',
                    isShow: true,
                });
            }
        },
    },
    mounted() {
        const resizeHandler = () => {
            const gameSize = Utils_1.Utils.getGameSize();
            const titleEle = document.querySelector('.title-screen');
            titleEle.style.width = `${gameSize.width}px`;
            titleEle.style.height = `${gameSize.height}px`;
            // Set base font-size
            document.querySelector('body').style.fontSize = `${0.043 * gameSize.width}px`;
        };
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        this.checkMaintenanceMode();
    },
});
